import React, { useState } from 'react';
import locations from './locationsData';
import LocationsView from './LocationsView';
const Contact = ({shops}) => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: ''
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Form submission is handled by Netlify
    };

    return (
        <div>
              <LocationsView shops={shops} />
        <div className="contact-page" style={{
            maxWidth: '600px',
            margin: '0 auto',
            padding: '20px',
            fontFamily: 'Arial, sans-serif'
        }}>
            <h1 style={{
                textAlign: 'center',
                color: '#333',
                marginBottom: '30px'
            }}>Contact Us</h1>
            <form
                name="contact"
                method="POST"
                data-netlify="true"
                data-netlify-honeypot="bot-field"
                onSubmit={handleSubmit}
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '20px'
                }}
            >
                <input type="hidden" name="form-name" value="contact" />
                <p style={{ display: 'none' }}>
                    <label>
                        Don't fill this out if you're human: 
                        <input name="bot-field" />
                    </label>
                </p>

                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <label htmlFor="location" style={{
                        marginBottom: '5px',
                        fontWeight: 'bold',
                        color: '#555'
                    }}>Location:</label>
                    <select
                        id="location"
                        name="location"
                        value={formData.location || ''}
                        onChange={handleChange}
                        required
                        style={{
                            padding: '10px',
                            border: '1px solid #ddd',
                            borderRadius: '4px',
                            fontSize: '16px'
                        }}
                    >
                        <option value="">Select a location</option>
                        {locations.map((location, index) => (
                            <option key={index} value={location.label}>
                                {location.label} - {location.address?.[0]} {location.address?.[1]}
                            </option>
                        ))}
                    </select>
                </div>
                
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <label htmlFor="name" style={{
                        marginBottom: '5px',
                        fontWeight: 'bold',
                        color: '#555'
                    }}>Name:</label>
                    <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        style={{
                            padding: '10px',
                            border: '1px solid #ddd',
                            borderRadius: '4px',
                            fontSize: '16px'
                        }}
                    />
                </div>

                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <label htmlFor="email" style={{
                        marginBottom: '5px',
                        fontWeight: 'bold',
                        color: '#555'
                    }}>Email:</label>
                    <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        style={{
                            padding: '10px',
                            border: '1px solid #ddd',
                            borderRadius: '4px',
                            fontSize: '16px'
                        }}
                    />
                </div>

                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <label htmlFor="phone" style={{
                        marginBottom: '5px',
                        fontWeight: 'bold',
                        color: '#555'
                    }}>Phone Number:</label>
                    <input
                        type="tel"
                        id="phone"
                        name="phone"
                        value={formData.phone || ''}
                        onChange={handleChange}
                        style={{
                            padding: '10px',
                            border: '1px solid #ddd',
                            borderRadius: '4px',
                            fontSize: '16px'
                        }}
                    />
                </div>

                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <label htmlFor="message" style={{
                        marginBottom: '5px',
                        fontWeight: 'bold',
                        color: '#555'
                    }}>Message:</label>
                    <textarea
                        id="message"
                        name="message"
                        rows="5"
                        value={formData.message}
                        onChange={handleChange}
                        required
                        style={{
                            padding: '10px',
                            border: '1px solid #ddd',
                            borderRadius: '4px',
                            fontSize: '16px',
                            resize: 'vertical'
                        }}
                    />
                </div>

                <button type="submit" style={{
                    padding: '12px 20px',
                    backgroundColor: '#000000ff',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    fontSize: '16px',
                    cursor: 'pointer',
                    transition: 'background-color 0.3s'
                }}>Send Message</button>
            </form>
        </div>
        </div>
    );
};

export default Contact;